import type {BioIconProps} from '../../icons/common-types'

export default function ValueFirstChoicesLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-2 text-2xl font-semibold tablet:gap-0 tablet:text-base">
      <svg
        width="273"
        height="273"
        viewBox="0 0 273 273"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...attributes}
      >
        <path
          d="M53.881 148.24L7.39453 205.051L50.3633 213.644L67.5508 265.207L112.742 193.501M218.721 148.24L265.207 205.051L222.238 213.644L205.051 265.207L159.859 193.501"
          stroke="white"
          strokeWidth="14.7892"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.7695 101.926C41.7695 126.997 51.729 151.041 69.4571 168.77C87.1851 186.498 111.23 196.457 136.301 196.457C161.372 196.457 185.416 186.498 203.144 168.77C220.873 151.041 230.832 126.997 230.832 101.926C230.832 76.8546 220.873 52.8102 203.144 35.0822C185.416 17.3541 161.372 7.39459 136.301 7.39459C111.23 7.39459 87.1851 17.3541 69.4571 35.0822C51.729 52.8102 41.7695 76.8546 41.7695 101.926Z"
          stroke="white"
          strokeWidth="14.7892"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.364 47.98L156.664 76.1446H181.035C182.377 76.1118 183.697 76.4846 184.824 77.2143C185.95 77.9439 186.83 78.9964 187.349 80.2342C187.868 81.4721 188.001 82.8375 187.731 84.1522C187.461 85.4669 186.801 86.6695 185.837 87.6029L163.458 109.58L175.856 138.054C176.411 139.358 176.54 140.805 176.225 142.187C175.91 143.569 175.167 144.816 174.102 145.752C173.037 146.687 171.704 147.263 170.293 147.397C168.882 147.531 167.465 147.217 166.243 146.499L136.279 129.644L106.316 146.487C105.093 147.187 103.683 147.488 102.281 147.347C100.88 147.207 99.5571 146.632 98.4982 145.703C97.4393 144.774 96.697 143.537 96.375 142.166C96.053 140.795 96.1674 139.357 96.7021 138.054L109.1 109.58L86.7219 87.5571C85.7577 86.6237 85.0974 85.421 84.8276 84.1064C84.5578 82.7917 84.6909 81.4262 85.2095 80.1884C85.7281 78.9506 86.6082 77.8981 87.7346 77.1685C88.861 76.4388 90.1813 76.066 91.523 76.0988H115.895L130.206 47.98C130.791 46.8743 131.665 45.9489 132.736 45.3034C133.808 44.6579 135.034 44.3168 136.285 44.3168C137.536 44.3168 138.762 44.6579 139.834 45.3034C140.905 45.9489 141.779 46.8743 142.364 47.98Z"
          stroke="white"
          strokeWidth="14.7892"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <span className="ml-1">Value First Choices</span>
    </div>
  )
}
